<template>
    <b-container class="access-api-key">
        <b-row>
            <b-col cols="6">
                <b-row>
                    <b-col cols="2"><strong>Clave</strong></b-col>
                    <b-col cols="4">{{access.key}}</b-col>
                </b-row>
            </b-col>
            <b-col cols="6">
                <b-row>
                    <b-col cols="2"><strong>Expira</strong></b-col>
                    <b-col cols="4">{{access.expires}}</b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import moment from 'moment';

export default {
    name: 'Apis',
    data: function() {
        return {
            access: {
                key: '',
                expires: ''
            }
        }
    },
    props: {
        details: Object,
    },
    created: function() {
        this.setData();
    },
    methods: {
        setData: function() {
            var vm = this;
            if (vm.details.key) {
                vm.access.key = vm.details.key.substr(vm.access.key.length - 8);
                const expires = vm.details.expires.substr(0, 10);
                vm.access.expires = moment(expires, "YYYY-MM-DD").locale('es').format("DD MMMM YYYY");
            }
        }
    }
}
</script>
